import { render, staticRenderFns } from "./cityTotal.vue?vue&type=template&id=0edd58ad&scoped=true"
import script from "./cityTotal.vue?vue&type=script&lang=js"
export * from "./cityTotal.vue?vue&type=script&lang=js"
import style0 from "./cityTotal.vue?vue&type=style&index=0&id=0edd58ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd58ad",
  null
  
)

export default component.exports